module.exports = __webpack_public_path__ + "img/partners8.719f552e.jpg";